export { useBurnAnimations } from "./use-burn-animations";
export { useBurnsInfinite, useTotalBurned, useUserBurns } from "./use-burn-data";
